import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
const SummaryAthlete = () => {
  return (
    <>
      <Container fluid>
        <div className="py-4 px-1 px-sm-4">
          <Link to="/home-for-athlete">
            <Button color="primary">Back</Button>
          </Link>{" "}
        </div>
      </Container>
      <Container className="term-and-condition-main">
        <div>
          <p className="text-center terms-title">
            Brand Ambassadors feel free to share this information with Fans
          </p>
          <p className="terms-title p-0">
            <a
              className="text-dark"
              target="_blank"
              href="https://fans-help-players-athlete.web.app"
            >
              FANSHELPPLAYERS.com
            </a>
          </p>
          <p className="termsPoint">
            The FHP site registers{" "}
            <b>student athletes (SA) from colleges across the USA</b>, and from
            high schools in several states. Fans visiting the FHP site can link
            to SA social media posts. Fans visiting the FHP site can{" "}
            <b>
              purchase an NIL Memento, such as Team Spirit badge with endorsing
              SA name and SA photo.
            </b>
          </p>
        </div>
      </Container>
    </>
  );
};

export default SummaryAthlete;
